"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingDecisionCommentsService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const queries_1 = require("./queries");
const mutations_1 = require("./mutations");
class MeetingDecisionCommentsService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.getComments = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingProjectDecision, variables, options, requestOptions);
      return response.data.meetings.meeting.question.projectDecision.rating.history;
    });
    this.getCurrentUserComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingProjectDecisionReplies, variables, options, requestOptions);
      return response.data.meetings.meeting.question.projectDecision.rating.historyReplies.parent;
    });
    this.getThread = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingProjectDecisionReplies, variables, options, requestOptions);
      return response.data.meetings.meeting.question.projectDecision.rating.historyReplies.replies;
    });
    this.getProjectDecisionHistory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingProjectDecisionHistory, variables, options, requestOptions);
      return response.data.meetings.meeting.question.projectDecision.history;
    });
    this.saveFirstComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.addComment, variables, options, requestOptions);
      return response.data.meetings.questions.projectDecisionRating.addComment;
    });
    this.saveThreadComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.replyComment, variables, options, requestOptions);
      return response.data.meetings.questions.projectDecisionRating.replyComment.add;
    });
    this.editThreadComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.editThreadComment, variables, options, requestOptions);
      return response.data.meetings.questions.projectDecisionRating.editComment;
    });
    this.editComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.editComment, variables, options, requestOptions);
      return response.data.meetings.questions.projectDecisionRating.editComment;
    });
    this.deleteThreadComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.deleteThreadComment, variables, options, requestOptions);
      return response.data.meetings.questions.projectDecisionRating.replyComment.delete;
    });
    this.deleteComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.deleteComment, variables, options, requestOptions);
      return response.data.meetings.questions.projectDecisionRating.deleteComment;
    });
    this.readHistory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.readHistory, variables, options, requestOptions);
      return response.data.history.readHistory;
    });
    this.sendProjectDecisionHistoryComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.projectDecisionManualComment, variables, options, requestOptions);
      return response.data.meetings.questions.projectDecisionManualComment;
    });
  }
}
exports.MeetingDecisionCommentsService = MeetingDecisionCommentsService;
const meetingDecisionCommentsService = new MeetingDecisionCommentsService();
exports.default = meetingDecisionCommentsService;